export default __webpack_public_path__ + "static/media/ReitanWelcomeIMG.a284b228.png";